import { useGetCurrent } from '@BUP/hooks/Current/useGetCurrent'
import BupLoading from '@BUP/components/Loading/Main'
import { createContext } from 'react'

export const RolesContext = createContext()

export const RolesContextProvider = ({ children }) => {
  const {
    data: roles,
    isLoading
  } = useGetCurrent('roles', 3)
  if (isLoading) return <BupLoading />
  if (!roles) return null
  return <RolesContext.Provider value={roles}>{children}</RolesContext.Provider>
}
